import React from 'react';
import User from '../../models/user';

import './table.scss';

type Props = { users: User[]; handleClick: () => void };

function Table(props: Props) {
  return (
    <table className="table">
      <thead className="table-header">
        <tr className="table-row">
          <th className="table-cell">Name</th>
          <th className="table-cell">Rating</th>
          <th className="table-cell">Guesses</th>
          <th className="table-cell">Date</th>
          <th className="table-cell">
            <button className="table-button" onClick={props.handleClick}>
              Clear
            </button>
          </th>
        </tr>
      </thead>
      <tbody className="table-body">
        {props.users.map((user, index) => (
          <tr className="table-row" key={index}>
            <td className="table-cell">{user.name}</td>
            <td className="table-cell">{user.rating}</td>
            <td className="table-cell">{user.guesses}</td>
            <td className="table-cell">{user.date}</td>
            <td className="table-cell"></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
